import { CrudService } from 'nest-utilities-client';

export abstract class CustomCrudService<
  ModelType,
> extends CrudService<ModelType> {}
